import { DataCollectionInterface } from '../../interfaces/data-collection.interface';

export class DeleteDataCollection {
    public static readonly type = '[DataCollection] Delete data collection';

    constructor(public dataCollection: DataCollectionInterface) { }
}
